import {
  initialPeopleToFollow,
  PeopleToFollowState
} from '../states/people-to-follow.state';
import { Action, createReducer, on } from '@ngrx/store';
import {
  followSuggestedPerson,
  loadPeopleToFollowMini,
  loadPeopleToFollowError,
  loadPeopleToFollowMiniSuccess,
  suggestedPersonError,
  suggestedPersonSuccess,
  unFollowSuggestedPerson
} from '../actions/people-to-follow.actions';
import {
  lightUserStateInitial,
  LightUserStateModel
} from '../states/light-user-state.model';

const reducer = createReducer(
  initialPeopleToFollow,
  on(loadPeopleToFollowMini, state => ({
    ...state,
    error: '',
    loading: true,
    peopleState: []
  })),

  on(loadPeopleToFollowMiniSuccess, (state, { users }) => ({
    ...state,
    peopleState:
      users?.map(user => ({
        ...lightUserStateInitial,
        user
      })) || [],
    error: '',
    loading: false
  })),

  on(loadPeopleToFollowError, (state, { error }) => ({
    ...state,
    peopleState: [],
    loading: false,
    error
  })),

  on(followSuggestedPerson, (state, { input }) => ({
    ...state,
    peopleState: state?.peopleState?.map((p: LightUserStateModel) => {
      if (p.user.ID !== input.followeeId) return p;
      return {
        ...p,
        loading: true,
        error: ''
      };
    })
  })),

  on(unFollowSuggestedPerson, (state, { input }) => ({
    ...state,
    peopleState: state?.peopleState?.map((p: LightUserStateModel) => {
      if (p.user.ID !== input.followeeId) return p;
      return {
        ...p,
        loading: true,
        error: ''
      };
    })
  })),

  on(suggestedPersonError, (state, { error, followeeId }) => ({
    ...state,
    peopleState: state?.peopleState?.map((p: LightUserStateModel) => {
      if (p.user.ID !== followeeId) return p;
      return {
        ...p,
        loading: false,
        error
      };
    })
  })),

  on(suggestedPersonSuccess, (state, { followeeId, followed }) => ({
    ...state,
    peopleState: state?.peopleState?.map((p: LightUserStateModel) => {
      if (p.user.ID !== followeeId) return p;
      return {
        ...p,
        loading: false,
        following: followed
      };
    })
  }))
);

export function peopleToFollowReducers(
  state: PeopleToFollowState | undefined,
  action: Action
): PeopleToFollowState {
  return reducer(state, action);
}
